import { Slider } from 'antd';
import { SliderRangeProps, SliderSingleProps } from 'antd/lib/slider';
import { FC } from 'react';

export const ILSSlider: FC<SliderSingleProps | SliderRangeProps> = (props) => {
  return <Slider {...props} />;
};
